/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ILanguageCode {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nb = 'nb',
  Nl = 'nl',
  Pt = 'pt',
  Ru = 'ru',
  Zh = 'zh',
}
